import { render, staticRenderFns } from "./BackupDetails.vue?vue&type=template&id=e3f29f44&"
import script from "./BackupDetails.vue?vue&type=script&lang=ts&"
export * from "./BackupDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports